module.exports = __webpack_public_path__ + "img/fondoNormal.f7bda457.jpg";